import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/transferrinSaturation";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	transferrinSaturation: {
		id: "ktx.transferrinSaturation.title",
		defaultMessage: "TFS"
	},
	value: {
		id: "ktx.transferrinSaturation.field.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_transferrinSaturation",
	value: {
		schemaId: "transferrinSaturation",
		title: messages.transferrinSaturation,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
